import isEmpty from "lodash-es/isEmpty";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EodMelcoEodModelsEodSetting, useConfirm, } from "melco-shared-logic";
import { Key } from "antd/lib/table/interface";
import { useDeleteEodSettingss } from "../../hooks/settings/useDeleteEodSettings";

type BulkActionDeleteEodSettingsFormatsProps<T> = {
    selectedRowKeys: Key[];
    setSelectedRowKeys: (keys: Key[]) => void;
    refetch?: () => Promise<any>;
    data?: T[];
};

export const BulkActionDeleteEodSettings: React.FC<
    BulkActionDeleteEodSettingsFormatsProps<EodMelcoEodModelsEodSetting>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
    const { t } = useTranslation();
    // if (selectedRowKeys)
    //     alert(selectedRowKeys)
    const deleteEodSettings = useDeleteEodSettingss();

    const confirmDelete = useConfirm(
        async () => {

            await deleteEodSettings();

            if (refetch) {
                refetch();
            }

            // // keep items that were not deleted selected
            setSelectedRowKeys([]);
        },
        {
            translationPrefix: "eodsettings.actions.delete",
            translationOptions: {
                count: selectedRowKeys.length,
            },
        }
    );

    if (isEmpty(selectedRowKeys)) {
        return null;
    }

    return (
        <Button
            key="bulk-delete"
            icon={<DeleteIcon />}
            onClick={() => {
                confirmDelete();
            }}
        >
            {t("eodsettings.actions.delete.button")}
        </Button>
    );
};
